import React from "react";
import { withState } from "@mna/react";
import LocationScreen from "../find-care-options/location";
import { getUrlSearchParamsValue } from "../../features/utils";

const FacilitySearch = (props) => <LocationScreen {...{ ...props }} />;
export default withState({
  async didMount({ state, setState, actions, history }) {
    localStorage.setItem("careoption", "");

    actions.setTriageBio({ sessionId: new Date().getTime() });
    var organizationId = getUrlSearchParamsValue(window.location.search);
    localStorage.setItem("orgid", organizationId);    
    await actions.validateOrganizationDetails(
      state,
      setState,
      actions,
      history,
      organizationId
    );
  },
})(FacilitySearch);
